var filtersForm = document.getElementById('resource-filters');

addEventListener('page:loaded', initResourcesList);

function initResourcesList() {
    filtersForm.addEventListener('change', getResources);
}

function getResources() {
    oc.request('#resource-filters', 'onGetResources', {
        query: getFiltersObject(),
        data: {
            page: 1
        },
        update: {
            'resources/results': true
        }
    });
}

function getFiltersObject() {
    var formData = new FormData(document.getElementById('resource-filters'));
    var filters = {
        page: 1
    };
    formData.forEach((value, key) => {
        filters[key] = value;
    });
    return filters;
}